"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("./_icons.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SvgIcon = function SvgIcon(_ref) {
  var children = _ref.children,
      style = _ref.style,
      viewBox = _ref.viewBox,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, ["children", "style", "viewBox", "className"]);

  return _react2.default.createElement(
    "svg",
    Object.assign({
      xmlns: "http://www.w3.org/2000/svg"
    }, other, {
      className: className,
      viewBox: viewBox
    }),
    children
  );
};

SvgIcon.defaultProps = {
  viewBox: "0 0 24 24",
  preserveAspectRatio: "xMidYMid meet"
};

SvgIcon.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
  viewBox: _propTypes2.default.string
};

exports.default = SvgIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/internal/SvgIcon.js
// module id = 33
// module chunks = 0